<template>
  <div :style="{ position: 'relative', height: height, width: '100%' }">
    <Doughnut
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="heightNum"
    />
    <div class="sac-indicator-center">
      <div class="sac-indicator-value" :style="{ color: color }">{{ value }}</div>
      <div class="sac-indicator-level" v-if="level">{{ level }}</div>
    </div>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs/legacy';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

export default {
    name: 'SacIndicatorChart',
    components: { Doughnut },
    props: {
        value: { type: Number, default: 0 },
        max: { type: Number, default: 100 },
        level: { type: String, default: '' },
        color: { type: String, default: '#1976D2' },
        height: { type: String, default: '220px' },
    },
    data() {
        return {
            chartId: 'sac-indicator-chart',
            datasetIdKey: 'label',
            width: 300,
            cssClasses: '',
            styles: {},
            plugins: [],
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                cutout: '75%',
                circumference: 360,
                rotation: 270,
                plugins: { legend: { display: false }, tooltip: { enabled: false } },
            },
        };
    },
    computed: {
        chartData() {
            const safeValue = Math.max(0, Math.min(this.value, this.max));
            return {
                datasets: [
                    {
                        data: [safeValue, this.max - safeValue],
                        backgroundColor: [this.color, 'rgba(255, 255, 255, 0.12)'],
                        borderWidth: 0,
                    },
                ],
            };
        },
        heightNum() {
            return parseInt(this.height, 10) || 220;
        },
    },
};
</script>

<style scoped>
.sac-indicator-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    pointer-events: none;
}
.sac-indicator-value {
    font-size: 36px;
    font-weight: 700;
    line-height: 1;
}
.sac-indicator-level {
    font-size: 12px;
    color: var(--color-navy-on-soft, rgba(255, 255, 255, 0.6));
    margin-top: 4px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
</style>
